// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://api.dev.lenbachgaerten-service.com/api/v1/',
  userProfileImageUrl: 'http://api.dev.lenbachgaerten-service.com/uploads/profile/image',
  companyImageUrl: 'http://api.dev.lenbachgaerten-service.com/uploads/company/image',
  openHouseImageUrl: 'http://api.dev.lenbachgaerten-service.com/uploads/open-house/image',
  apiKey: '$1$wFXtfEbD$7JgvSQqbKfcIp2WGggpdO1',
  version: require('../../package.json').version,
  buildDate: require('../../package.json').buildDate,
  author: require('../../package.json').author
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
